import {
  getAgents,
  createAgent,
  updateAgent,
  deleteAgent,
  sendAgentPasswordLink,
} from '@/api/agents'

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
}

export const getters = {
  getAgents: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
}

const resolveAccountId = async ({ dispatch, rootGetters }) => {
  let currentUser = rootGetters['auth/getCurrentUser']
  if (!currentUser) {
    await dispatch('auth/validityCheck', null, { root: true })
    currentUser = rootGetters['auth/getCurrentUser']
  }
  return currentUser?.accounts?.[0]?.id
}

export const actions = {
  async get({ commit, dispatch, rootGetters }) {
    const accountId = await resolveAccountId({ dispatch, rootGetters })
    if (!accountId) return
    commit('SET_UI_FLAG', { isFetching: true })
    try {
      const response = await getAgents(accountId)
      commit('SET_AGENTS', response.data)
    } finally {
      commit('SET_UI_FLAG', { isFetching: false })
    }
  },

  async create({ commit, dispatch, rootGetters }, payload) {
    const accountId = await resolveAccountId({ dispatch, rootGetters })
    commit('SET_UI_FLAG', { isCreating: true })
    try {
      const response = await createAgent(accountId, payload)
      commit('SET_AGENTS', response.data)
    } finally {
      commit('SET_UI_FLAG', { isCreating: false })
    }
  },

  async update({ commit, dispatch, rootGetters }, { id, ...payload }) {
    const accountId = await resolveAccountId({ dispatch, rootGetters })
    commit('SET_UI_FLAG', { isUpdating: true })
    try {
      const response = await updateAgent(accountId, id, payload)
      commit('SET_AGENTS', response.data)
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false })
    }
  },

  async sendPasswordLink({ dispatch, rootGetters }, id) {
    const accountId = await resolveAccountId({ dispatch, rootGetters })
    await sendAgentPasswordLink(accountId, id)
  },

  async delete({ commit, dispatch, rootGetters }, id) {
    const accountId = await resolveAccountId({ dispatch, rootGetters })
    commit('SET_UI_FLAG', { isDeleting: true })
    try {
      await deleteAgent(accountId, id)
      commit('DELETE_AGENT', id)
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false })
    }
  },
}

export const mutations = {
  SET_AGENTS($state, records) {
    $state.records = records
  },
  DELETE_AGENT($state, id) {
    $state.records = $state.records.filter(agent => agent.id !== id)
  },
  SET_UI_FLAG($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
